import React from "react";
import "../Styles/ClientMenuPopup.css";

function ClientMenuPopup({ item, onToggleActive, onDelete, onClose }) {
    
  return (
    <div className="menu-popup">
      <button
        className="close-btn-1 click-effect"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        ×
      </button>
      <button
        className="menu-btn"
        onClick={(e) => {
          e.stopPropagation();
          onToggleActive(item,!item.IsActive);
        }}
      >
        {item.IsActive ? "Set Inactive" : "Set Active"}
      </button>

      <button
        className="menu-btn delete"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        Delete
      </button>
    </div>
  );
}

export default ClientMenuPopup;
